import { render } from "./CreateRelationModal.vue?vue&type=template&id=54bf49ac"
import script from "./CreateRelationModal.vue?vue&type=script&lang=js"
export * from "./CreateRelationModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/harlan/sites/kintell-env/api/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CreateRelationModal.vue"]])

export default __exports__